import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.74,11.23,18.3,2.69A1.51,1.51,0,0,0,17,2H7a1.49,1.49,0,0,0-1.26.69L.27,11.23a1.51,1.51,0,0,0,0,1.61l5.44,8.47A1.5,1.5,0,0,0,7,22H17a1.5,1.5,0,0,0,1.26-.69l5.43-8.47A1.49,1.49,0,0,0,23.74,11.23ZM12,17a5,5,0,1,1,5-5A5,5,0,0,1,12,17Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }